export default __webpack_public_path__ + "579728ee291796a5641a242b16422585.png";